<template>
  <g class="persons">
    <template v-for="(personsGroup , key) in personsGroupByPosition">
      <pin-person-single
        v-if="isUnSelectedSinglePeronPin(personsGroup)"
        :key="key"
        :person="personsGroup[0]"
        :visualization-pin-size="visualizationPinSize"
      />
      <pin-person-multiple
        v-else-if="isUnSelectedMultiplePeronPin(personsGroup)"
        :key="key"
        :persons="personsGroup"
        :visualization-pin-size="visualizationPinSize"
      />
    </template>

    <pin-person-single
      v-if="selectedSinglePersonPin"
      :person="selectedSinglePersonPin"
      :visualization-pin-size="visualizationPinSize"
    />

    <pin-person-multiple
      v-if="selectedMultiplePersonPin"
      :persons="selectedMultiplePersonPin"
      :visualization-pin-size="visualizationPinSize"
    />
  </g>
</template>

<script>
import map from '@/mixins/map.js';

import pinPersonSingle from './person/single.vue';
import pinPersonMultiple from './person/multiple.vue';

export default {
  components: { pinPersonSingle, pinPersonMultiple },
  mixins: [map],
  computed: {
    svgElm: ({ $store }) => $store.state.map.svgElm,
    currentFloorId: ({ $store }) => $store.state.current.floorId,
    personsGroupByPosition: ({ $store, currentFloorId }) => $store.getters['area/personsGroupByPosition'](currentFloorId),
    // NOTE: 表示上何pxにしたいかの数値をpxToSvgSizeの引き数に書く
    visualizationPinSize() {
      if (!this.svgElm) {
        return {
          width: 0,
          height: 0,
        };
      }

      // NOTE: 表示上何pxにしたいかの数値を引き数に書く
      return {
        width: this.pxToSvgSize(48),
        height: this.pxToSvgSize(54.32),
      };
    },
    destination: ({ $store }) => $store.state.searchResult.destination,
    destinationList: ({ $store }) => $store.state.searchResult.destinations,
    selectedSinglePersonPin() {
      const exist = Object.keys(this.destination).length > 0 && this.destination.user;
      const groupKeys = Object.keys(this.personsGroupByPosition);
      if (!exist || groupKeys.length === 0) return false;

      let currentPerson = false;
      for (let [key, persons] of Object.entries(this.personsGroupByPosition)) {
        if (persons[0].user.id === this.destination.user.id) {
          currentPerson = this.personsGroupByPosition[key][0];
          break;
        };
      }
      return currentPerson;
    },
    selectedMultiplePersonPin() {
      if (this.destinationList.length == 0) return false;

      const exist = this.$store.state.current.isGroupSelected;
      const groupKeys = Object.keys(this.personsGroupByPosition);
      if (!exist || groupKeys.length === 0) return false;

      let currentPersons = false;
      for (let [key, persons] of Object.entries(this.personsGroupByPosition)) {
        if (persons[0].user.id === this.destinationList[0].user.id) {
          currentPersons = this.personsGroupByPosition[key];
          break;
        };
      }
      return currentPersons;
    },
    isUnSelectedSinglePeronPin() {
      return (persons) => {
        if (persons.length > 1) return false;

        return !this.selectedSinglePersonPin || persons[0].user.id !== this.destination.user.id;
      }
    },
    isUnSelectedMultiplePeronPin() {
      return (persons) => {
        if (persons.length === 1) return false;

        return !this.selectedMultiplePersonPin || persons.every((person) => this.destinationList.some((destination) => destination.id === person.id));
      };
    },
  },
  created() {
    this.$store.dispatch('area/getFloorThingExTags', this.currentFloorId);
  },
};
</script>



// WEBPACK FOOTER //
// person.vue?73a3011e